export enum DmsSystem {
  ANY,
  AWP_DMS_INTERFACE,
  DCOM,
  ETK
}
